import classNames from 'classnames';
import { ChevronRightIcon } from '@repo/icons';
import { formatDuration } from '@repo/date-time';

import type { ParkingDurationCardProps } from '@shared/types';
import DurationCard from '@shared/components/duration/DurationCard';

export default function DurationPresetCard({
  minutes,
  testId,
  onClick,
  color,
  compact = false,
}: ParkingDurationCardProps) {
  return (
    <DurationCard testId={testId} onClick={onClick} color={color} compact={compact}>
      <div
        className={classNames('flex-1 leading-4', {
          'text-lg': !compact,
          'text-base font-medium': compact,
          'text-brand': color === 'brand',
          'text-heading': color === 'white',
        })}
      >
        {formatDuration(minutes)}
      </div>
      <ChevronRightIcon size={18} color={color === 'white' ? 'text-brand-medium' : 'text-brand'} />
    </DurationCard>
  );
}
